/* tslint:disable */
/* eslint-disable */
/**
 * CMS
 * The CMS API description
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosResponse, AxiosInstance, AxiosRequestConfig } from "axios";
// @ts-ignore
import globalAxios from "@/config/axiosInstance";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
/**
 * ShowcaseApi - axios parameter creator
 * @export
 */
export const ShowcaseApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} device
     * @param {string} version
     * @param {string} versionTitle
     * @param {Array} mainSliders
     * @param {Array} infinitySliders
     * @param {Array} onlineCinemas
     * @param {Array} movieSliders
     * @param {Array} pentaBanners
     * @param {Array} materialUSilders
     * @param {Array} sportList
     * @param {Array} freeMovies
     * @param {Array} nostalgias
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    showCaseControllerCreateShowCaseForm: async (
      device: string,
      version: string,
      versionTitle: string,
      mainSliders: Array,
      infinitySliders: Array,
      onlineCinemas: Array,
      movieSliders: Array,
      pentaBanners: Array,
      materialUSilders: Array,
      sportList: Array,
      freeMovies: Array,
      nostalgias: Array,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'device' is not null or undefined
      if (device === null || device === undefined) {
        throw new RequiredError(
          "device",
          "Required parameter device was null or undefined when calling showCaseControllerCreateShowCaseForm."
        );
      }
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          "version",
          "Required parameter version was null or undefined when calling showCaseControllerCreateShowCaseForm."
        );
      }
      // verify required parameter 'versionTitle' is not null or undefined
      if (versionTitle === null || versionTitle === undefined) {
        throw new RequiredError(
          "versionTitle",
          "Required parameter versionTitle was null or undefined when calling showCaseControllerCreateShowCaseForm."
        );
      }
      // verify required parameter 'mainSliders' is not null or undefined
      if (mainSliders === null || mainSliders === undefined) {
        throw new RequiredError(
          "mainSliders",
          "Required parameter mainSliders was null or undefined when calling showCaseControllerCreateShowCaseForm."
        );
      }
      // verify required parameter 'infinitySliders' is not null or undefined
      if (infinitySliders === null || infinitySliders === undefined) {
        throw new RequiredError(
          "infinitySliders",
          "Required parameter infinitySliders was null or undefined when calling showCaseControllerCreateShowCaseForm."
        );
      }
      // verify required parameter 'onlineCinemas' is not null or undefined
      if (onlineCinemas === null || onlineCinemas === undefined) {
        throw new RequiredError(
          "onlineCinemas",
          "Required parameter onlineCinemas was null or undefined when calling showCaseControllerCreateShowCaseForm."
        );
      }
      // verify required parameter 'movieSliders' is not null or undefined
      if (movieSliders === null || movieSliders === undefined) {
        throw new RequiredError(
          "movieSliders",
          "Required parameter movieSliders was null or undefined when calling showCaseControllerCreateShowCaseForm."
        );
      }
      // verify required parameter 'pentaBanners' is not null or undefined
      if (pentaBanners === null || pentaBanners === undefined) {
        throw new RequiredError(
          "pentaBanners",
          "Required parameter pentaBanners was null or undefined when calling showCaseControllerCreateShowCaseForm."
        );
      }
      // verify required parameter 'materialUSilders' is not null or undefined
      if (materialUSilders === null || materialUSilders === undefined) {
        throw new RequiredError(
          "materialUSilders",
          "Required parameter materialUSilders was null or undefined when calling showCaseControllerCreateShowCaseForm."
        );
      }
      // verify required parameter 'sportList' is not null or undefined
      if (sportList === null || sportList === undefined) {
        throw new RequiredError(
          "sportList",
          "Required parameter sportList was null or undefined when calling showCaseControllerCreateShowCaseForm."
        );
      }
      // verify required parameter 'freeMovies' is not null or undefined
      if (freeMovies === null || freeMovies === undefined) {
        throw new RequiredError(
          "freeMovies",
          "Required parameter freeMovies was null or undefined when calling showCaseControllerCreateShowCaseForm."
        );
      }
      // verify required parameter 'nostalgias' is not null or undefined
      if (nostalgias === null || nostalgias === undefined) {
        throw new RequiredError(
          "nostalgias",
          "Required parameter nostalgias was null or undefined when calling showCaseControllerCreateShowCaseForm."
        );
      }
      const localVarPath = `/v1/cms/api/showcase`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      if (device !== undefined) {
        localVarFormParams.append("device", device as any);
      }

      if (version !== undefined) {
        localVarFormParams.append("version", version as any);
      }

      if (versionTitle !== undefined) {
        localVarFormParams.append("versionTitle", versionTitle as any);
      }

      if (mainSliders !== undefined) {
        localVarFormParams.append("mainSliders", mainSliders as any);
      }

      if (infinitySliders !== undefined) {
        localVarFormParams.append("infinitySliders", infinitySliders as any);
      }

      if (onlineCinemas !== undefined) {
        localVarFormParams.append("onlineCinemas", onlineCinemas as any);
      }

      if (movieSliders !== undefined) {
        localVarFormParams.append("movieSliders", movieSliders as any);
      }

      if (pentaBanners !== undefined) {
        localVarFormParams.append("pentaBanners", pentaBanners as any);
      }

      if (materialUSilders !== undefined) {
        localVarFormParams.append("materialUSilders", materialUSilders as any);
      }

      if (sportList !== undefined) {
        localVarFormParams.append("sportList", sportList as any);
      }

      if (freeMovies !== undefined) {
        localVarFormParams.append("freeMovies", freeMovies as any);
      }

      if (nostalgias !== undefined) {
        localVarFormParams.append("nostalgias", nostalgias as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} device
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    showCaseControllerGetArtist: async (
      pageNumber: number,
      pageIndex: number,
      device: string,
      version: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageNumber' is not null or undefined
      if (pageNumber === null || pageNumber === undefined) {
        throw new RequiredError(
          "pageNumber",
          "Required parameter pageNumber was null or undefined when calling showCaseControllerGetArtist."
        );
      }
      // verify required parameter 'pageIndex' is not null or undefined
      if (pageIndex === null || pageIndex === undefined) {
        throw new RequiredError(
          "pageIndex",
          "Required parameter pageIndex was null or undefined when calling showCaseControllerGetArtist."
        );
      }
      // verify required parameter 'device' is not null or undefined
      if (device === null || device === undefined) {
        throw new RequiredError(
          "device",
          "Required parameter device was null or undefined when calling showCaseControllerGetArtist."
        );
      }
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          "version",
          "Required parameter version was null or undefined when calling showCaseControllerGetArtist."
        );
      }
      const localVarPath = `/v1/cms/api/showcase`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageIndex !== undefined) {
        localVarQueryParameter["pageIndex"] = pageIndex;
      }

      if (device !== undefined) {
        localVarQueryParameter["device"] = device;
      }

      if (version !== undefined) {
        localVarQueryParameter["version"] = version;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    showCaseControllerGetUserMedia: async (
      filename: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'filename' is not null or undefined
      if (filename === null || filename === undefined) {
        throw new RequiredError(
          "filename",
          "Required parameter filename was null or undefined when calling showCaseControllerGetUserMedia."
        );
      }
      const localVarPath = `/v1/cms/api/showcase-media/{filename}`.replace(
        `{${"filename"}}`,
        encodeURIComponent(String(filename))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ShowcaseApi - functional programming interface
 * @export
 */
export const ShowcaseApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} device
     * @param {string} version
     * @param {string} versionTitle
     * @param {Array} mainSliders
     * @param {Array} infinitySliders
     * @param {Array} onlineCinemas
     * @param {Array} movieSliders
     * @param {Array} pentaBanners
     * @param {Array} materialUSilders
     * @param {Array} sportList
     * @param {Array} freeMovies
     * @param {Array} nostalgias
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async showCaseControllerCreateShowCaseForm(
      device: string,
      version: string,
      versionTitle: string,
      mainSliders: Array,
      infinitySliders: Array,
      onlineCinemas: Array,
      movieSliders: Array,
      pentaBanners: Array,
      materialUSilders: Array,
      sportList: Array,
      freeMovies: Array,
      nostalgias: Array,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ShowcaseApiAxiosParamCreator(
        configuration
      ).showCaseControllerCreateShowCaseForm(
        device,
        version,
        versionTitle,
        mainSliders,
        infinitySliders,
        onlineCinemas,
        movieSliders,
        pentaBanners,
        materialUSilders,
        sportList,
        freeMovies,
        nostalgias,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} device
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async showCaseControllerGetArtist(
      pageNumber: number,
      pageIndex: number,
      device: string,
      version: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ShowcaseApiAxiosParamCreator(
        configuration
      ).showCaseControllerGetArtist(
        pageNumber,
        pageIndex,
        device,
        version,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async showCaseControllerGetUserMedia(
      filename: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ShowcaseApiAxiosParamCreator(
        configuration
      ).showCaseControllerGetUserMedia(filename, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * ShowcaseApi - factory interface
 * @export
 */
export const ShowcaseApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} device
     * @param {string} version
     * @param {string} versionTitle
     * @param {Array} mainSliders
     * @param {Array} infinitySliders
     * @param {Array} onlineCinemas
     * @param {Array} movieSliders
     * @param {Array} pentaBanners
     * @param {Array} materialUSilders
     * @param {Array} sportList
     * @param {Array} freeMovies
     * @param {Array} nostalgias
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async showCaseControllerCreateShowCaseForm(
      device: string,
      version: string,
      versionTitle: string,
      mainSliders: Array,
      infinitySliders: Array,
      onlineCinemas: Array,
      movieSliders: Array,
      pentaBanners: Array,
      materialUSilders: Array,
      sportList: Array,
      freeMovies: Array,
      nostalgias: Array,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ShowcaseApiFp(configuration)
        .showCaseControllerCreateShowCaseForm(
          device,
          version,
          versionTitle,
          mainSliders,
          infinitySliders,
          onlineCinemas,
          movieSliders,
          pentaBanners,
          materialUSilders,
          sportList,
          freeMovies,
          nostalgias,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} device
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async showCaseControllerGetArtist(
      pageNumber: number,
      pageIndex: number,
      device: string,
      version: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ShowcaseApiFp(configuration)
        .showCaseControllerGetArtist(
          pageNumber,
          pageIndex,
          device,
          version,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async showCaseControllerGetUserMedia(
      filename: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ShowcaseApiFp(configuration)
        .showCaseControllerGetUserMedia(filename, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ShowcaseApi - object-oriented interface
 * @export
 * @class ShowcaseApi
 * @extends {BaseAPI}
 */
export class ShowcaseApi extends BaseAPI {
  /**
     * 
     * @param {string} device 
     * @param {string} version 
     * @param {string} versionTitle 
     * @param {Array} mainSliders 
     * @param {Array} infinitySliders 
     * @param {Array} onlineCinemas 
     * @param {Array} movieSliders 
     * @param {Array} pentaBanners 
     * @param {Array} materialUSilders 
     * @param {Array} sportList 
     * @param {Array} freeMovies 
     * @param {Array} nostalgias 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowcaseApi
     */
  public async showCaseControllerCreateShowCaseForm(
    device: string,
    version: string,
    versionTitle: string,
    mainSliders: Array,
    infinitySliders: Array,
    onlineCinemas: Array,
    movieSliders: Array,
    pentaBanners: Array,
    materialUSilders: Array,
    sportList: Array,
    freeMovies: Array,
    nostalgias: Array,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ShowcaseApiFp(this.configuration)
      .showCaseControllerCreateShowCaseForm(
        device,
        version,
        versionTitle,
        mainSliders,
        infinitySliders,
        onlineCinemas,
        movieSliders,
        pentaBanners,
        materialUSilders,
        sportList,
        freeMovies,
        nostalgias,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {number} pageNumber
   * @param {number} pageIndex
   * @param {string} device
   * @param {string} version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShowcaseApi
   */
  public async showCaseControllerGetArtist(
    pageNumber: number,
    pageIndex: number,
    device: string,
    version: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ShowcaseApiFp(this.configuration)
      .showCaseControllerGetArtist(
        pageNumber,
        pageIndex,
        device,
        version,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} filename
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShowcaseApi
   */
  public async showCaseControllerGetUserMedia(
    filename: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ShowcaseApiFp(this.configuration)
      .showCaseControllerGetUserMedia(filename, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
